import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyMessage: {
		id: 'polaris-ideas.idea-view.connections.content.empty-message-non-final',
		defaultMessage: 'No connections',
		description: 'Empty state for list of connections',
	},
});
